import React, { SVGProps } from 'react';

const CasinoClassicsIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.15432 1.98535H10.8857L13.3386 7.25678H6.69146L9.15432 1.98535ZM4.72003 7.25678L7.18289 1.98535H4.78003C4.42962 1.99492 4.08633 2.08648 3.7777 2.2527C3.46907 2.41893 3.20371 2.65518 3.00289 2.94249L0.407175 6.53964L0.402889 6.54535C0.250917 6.76228 0.137805 7.00397 0.0686035 7.25964H4.72003V7.25678ZM0.362889 9.04249H4.68289L7.42718 17.8439L0.521461 9.25678C0.465371 9.18879 0.412457 9.11824 0.362889 9.04535V9.04249ZM6.55289 9.04249H13.4772L10.1486 19.7611C10.0649 19.7657 9.98099 19.7667 9.89718 19.7639L6.55432 9.04392L6.55289 9.04249ZM15.3472 9.04249L12.6386 17.7611L19.4786 9.25535C19.5347 9.18736 19.5876 9.11681 19.6372 9.04392L15.3472 9.04249ZM19.93 7.25678C19.8611 7.00171 19.7485 6.76052 19.5972 6.54392L19.5929 6.53821L16.9972 2.94392C16.7964 2.6566 16.531 2.42036 16.2224 2.25413C15.9137 2.08791 15.5704 1.99634 15.22 1.98678V1.98535H12.8572L15.3086 7.25678H19.93Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default CasinoClassicsIcon;
